import Application from "../Application";
import Area, { IArea } from "./Area";
import { IRouter } from "../runtime/Router";
import EmptyPage from "../ui/pages/EmptyPage";
import { Layouts } from "../common/Constants";

import ShowFrontOfficeHomeInteractor from "../interactor/main/ShowFrontOfficeHomeInteractor";
import FormsPage from "../ui/pages/form/FormsPage";
import ShowFormsInteractor from "../interactor/form/ShowFormsInteractor";

export default class FrontOfficeHomeArea extends Area implements IArea {
  private application: Application;
  private router: IRouter;

  constructor(application: Application, router: IRouter) {
    super();
    this.application = application;
    this.router = router;
  }

  register(params: any) {
    this.router.registerRoutes(
      {
        path: "/",
        page: this.createPage({
          Page: FormsPage,
          action: this.showFormsPage.bind(this)
        }),
        options: {
          secure: true
        }
      },
      {
        path: "/home",
        page: this.createPage({
          Page: FormsPage,
          action: this.showFormsPage.bind(this)
        }),
        options: {
          secure: true
        }
      },
      {
        path: "/error",
        page: this.createPage({
          Page: EmptyPage,
          action: () => {}
        }),
        options: {
          secure: false,
          initialProps: {
            title: "Error",
            text: "page not found."
          },
          layout: Layouts.BASE
        }
      }
    );
  }

  public showFrontOfficeHomePage() {
    return this.application.container
      .resolve<ShowFrontOfficeHomeInteractor>("showFrontOfficeHome")
      .execute();
  }

  public showFormsPage() {
    return this.application.container
      .resolve<ShowFormsInteractor>("showForms")
      .execute();
  }
}
